export function updateMapType(e) {
  return {
    type: 'UPDATE_MAP_TYPE',
    customizations: {
      mapType: e.currentTarget.value.toLocaleLowerCase(),
    },
  };
}

export default ({
  updateMapType,
});



// WEBPACK FOOTER //
// ./src/store/actions/maps.js